export default __webpack_public_path__ + "static/media/mailchimp-freddie.1f89678b.svg";